import { CampaignDetail, RedeemResponse } from '@bzbs/react-api-client';
import { campaignPointType } from '../constant';

const isCodeAutoUse = (campaign: CampaignDetail, redeemData: RedeemResponse) => {
  if (campaign.IsNotAutoUse == true) {
    return campaign.IsRequireUniqueSerial === true;
  }

  return redeemData.IsUsed === true;
};

const isPointEnough = (
  campaign: CampaignDetail,
  userPoints: number,
  pointServiceBalance: { [key: string]: number },
  supportPointUnits: string[],
  quantity: number = 1
) => {
  if (campaign.PointType === campaignPointType.get) {
    return true;
  }

  if (supportPointUnits.length === 0) {
    return userPoints >= campaign.PointPerUnit * quantity;
  }

  const campaignPointServices = campaign.PointServices;

  if (campaignPointServices === null || campaignPointServices === undefined) {
    return userPoints >= campaign.PointPerUnit * quantity;
  }

  return supportPointUnits.some(unit => {
    return (pointServiceBalance[unit] ?? 0) >= (campaignPointServices[unit]?.AmountPerUnit ?? 0) * quantity;
  })
};

export { isCodeAutoUse, isPointEnough };
